var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('v-chip',{attrs:{"color":_vm.meta.color,"text-color":_vm.meta.textColor,"small":"","label":""}},[_c('v-icon',{attrs:{"left":"","x-small":""}},[_vm._v(_vm._s(_vm.meta.icon))]),_vm._v(" "+_vm._s(_vm.meta.label)+" ")],1):_c('span',{staticClass:"grey--text text-caption"},[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }